module.exports = __webpack_public_path__ + "img/area.292501e4.svg";